import { createFileRoute } from "@tanstack/react-router";
import { InvoiceForm } from "@/components/InvoiceForm";

export const Route = createFileRoute("/_auth/invoices/ap/new")({
  component: () => <InvoiceForm direction="ap" />,
});
